import React from "react";

const Warranty =()=>{

    return (
        <div className="regulations-detail">
            <div>
            <div>Bibo Mart cam kết tất cả hàng hoá được cung cấp bởi chúng tôi đều là sản phẩm chính hãng, có nguồn gốc, xuất xứ rõ ràng và đảm bảo chất lượng.</div>
            </div>
            <div>
            <div >
                <b className="index">1. Hình thức bảo hành</b>
            </div>
            <div className="box-list-style" >
                <ul className="pdl-20" >
                <li>Các sản phẩm do Bibo Mart cung cấp cho Quý khách sẽ được bảo hành theo chế độ bảo hành của Nhà sản xuất và/hoặc Nhà phân phối chính thức tương ứng. Điều kiện bảo hành được ghi rõ trong phiếu bảo hành của nhà sản xuất hoặc nhà nhập khẩu.</li>
                <li>Việc bảo hành tại chỗ hay mang đến trung tâm bảo hành phụ thuộc vào chính sách bảo hành cụ thể của từng hãng sản xuất. Thông tin về Trung tâm bảo hành được ghi trên Phiếu bảo hành kèm theo của sản phẩm bao gồm: Tên công ty, địa chỉ bảo hành, số điện thoại.</li>
                <li>Thời gian bảo hành được tính từ ngày tiếp nhận sản phẩm. Thời gian bảo hành bao lâu phụ thuộc vào tình trạng của từng sản phẩm và chính sách bảo hành của mỗi Nhà cung cấp.</li>
                <li>Nếu Quý khách có nhu cầu bảo hành, bảo trì đặc biệt, xin vui lòng liên hệ với chúng tôi để bổ sung hoặc thay đổi hình thức bảo hành, bảo trì cho phù hợp với điều kiện cụ thể của Quý khách.</li>
                </ul>
            </div>
            </div>
            <div>
            <div >
                <b className="index">2. Trách nhiệm bảo hành</b>
            </div>
            <div className="box-list-style" >
                <div>
                <b>Đối với các sản phẩm có Phiếu bảo hành của Nhà sản xuất hoặc nhà Nhập khẩu:</b>
                <ul className="pdl-20" >
                    <li>Quý khách vui lòng liên hệ trực tiếp với Trung tâm bảo hành để được chăm sóc. Các thông tin về Trung tâm bảo hành được ghi trên phiếu bảo hành kèm theo của sản phẩm.</li>
                    <li>Trong trường hợp Quý khách không đến được các Trung tâm bảo hành, Quý khách có thể yêu cầu chúng tôi hỗ trợ chuyển sản phẩm đi bảo hành.</li>
                </ul>
                </div>
                <div>
                <b>Đối với các sản phẩm có Phiếu bảo hành của Bibo Mart:</b>
                <ul className="pdl-20" >
                    <li>Bibo Mart chịu trách nhiệm bảo hành sản phẩm theo Quy định ghi trên phiếu bảo hành kèm theo sản phẩm.</li>
                    <li>Bảo hành sản phẩm tại nhà chỉ áp dụng đối với sản phẩm cồng kềnh (giường, cũi, đồ chơi ngoài trời…) trong nội thành.</li>
                </ul>
                </div>
            </div>
            </div>
            <div>
            <div>
                <b className="index">3. Chi phí phát sinh</b>
            </div>
            <div className="box-list-style" >
                <ul className="pdl-20" >
                <li>Miễn phí vận chuyển: trong trường hợp Bibo Mart hỗ trợ Khách hàng chuyển sản phẩm (không có Phiếu bảo hành của Bibo Mart) tới Nhà sản xuất/Nhà nhập khẩu để bảo hành trong phạm vi nội thành.</li>
                <li>Không miễn phí vận chuyển: trong trường hợp Bibo Mart hỗ trợ Khách hàng chuyển sản phẩm (không có Phiếu bảo hành của Bibo Mart) tới Nhà sản xuất/Nhà nhập khẩu để bảo hành không trong phạm vi nội thành.</li>
                <li>Chi phí phát sinh cho việc sữa chữa các sản phẩm không có Phiếu bảo hành của Bibo Mart (như thay thế linh kiện, …), Quý khách thanh toán theo cơ chế chính sách bảo hành của từng nhãn hàng.</li>
                </ul>
            </div>
            </div>
            <div>
            <div>
                <b className="index">4. Các trường hợp không được bảo hành</b>
            </div>
            <div className="box-list-style">
                <ul className="pdl-20">
                <li>Không có Phiếu bảo hành khi yêu cầu bảo hành sản phẩm.</li>
                <li>Tem bảo hành bị rách, không còn tem bảo hành, tem bảo hành dán đè, hoặc tem bảo hành bị sửa đổi (kể cả tem bảo hành gốc).</li>
                <li>Phiếu bảo hành không điền đầy đủ thông tin.</li>
                <li>Các thông tin trên sản phẩm không trùng khớp với thông tin ghi trên phiếu bảo hành.</li>
                <li>Sản phẩm hết thời gian bảo hành.</li>
                <li>Sản phẩm sử dụng không tuân theo hướng dẫn của Nhà sản xuất.</li>
                <li>Thiết bị hỏng hóc do tác động cơ học, biến dạng, rơi vỡ, va đập, trầy xước, bị hỏng do ẩm ướt, hoen rỉ, chảy nước, động vật xâm nhập vào hoặc các sự cố bất khả kháng như thiên tai, hoả hoạn, sử dụng sai điện áp quy định, cháy nổ hoặc con nguời làm hỏng....</li>
                <li>Tự ý tháo dỡ, sửa chữa bởi các cá nhân hoặc kỹ thuật viên không phải là nhân viên của Bibo Mart.</li>
                </ul>
            </div>
            </div>
            
        </div>
    )
}
export default Warranty;